<template>
  <loading
    v-model:active="isLoading"
    :can-cancel="false"
    loader="dots"
    color="#007bff"
    :height="45"
    :width="75"
    :is-full-page="true"
  ></loading>
  <!-- <AuthLogin v-show="!isAuth"></AuthLogin> -->

  <v-container fluid>
    <v-app-bar app elevation="0">
      <v-app-bar-title
        ><v-img
          :width="300"
          aspect-ratio="16/9"
          src="../assets/logo.png"
        ></v-img
      ></v-app-bar-title>
      <template v-slot:append>
        <v-item-group>
          <v-row>
            <v-col
              v-for="(item, index) in items"
              :key="index"
              :cols="12 / items.length"
            >
              <v-btn
                v-if="index < items.length - 2"
                size="small"
                @click="checkMenuSelection(item)"
                >{{ item }}</v-btn
              >
              <v-menu v-else open-on-hover>
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-bind="props"
                    size="small"
                    append-icon="mdi-chevron-down"
                    >{{ item }}</v-btn
                  >
                </template>
                <v-list v-if="index == items.length - 1">
                  <v-list-item
                    v-for="(item, index) in profile_dropdown_items"
                    :key="index"
                  >
                    <v-list-item
                      class="dropdown-items"
                      @click="profileChildrenEvents(item)"
                    >
                      {{ item }}
                    </v-list-item>
                  </v-list-item>
                </v-list>
                <v-list v-else>
                  <v-list-item
                    v-for="(item, index) in dashboard_dropdown_items"
                    :key="index"
                  >
                    <v-list-item>
                      {{ item }}
                    </v-list-item>
                  </v-list-item></v-list
                >
              </v-menu>
            </v-col>
          </v-row>
        </v-item-group>
      </template>
    </v-app-bar>
  </v-container>
  <!-- <ul style="display: flex; flex-direction: row">
    <li class="nav-item" style="padding-left: 30px; padding-right: 20px">
      <router-link class="nav-link" to="/">Left Bar</router-link>
    </li>
    <li class="nav-item">
      <router-link class="nav-link" to="/caraSearch">Carrousel</router-link>
    </li>
  </ul> -->
</template>
<script>
// import { ref } from "vue";
import { useRouter } from "vue-router";
// import { useStore } from "vuex";
import { ref, onMounted, inject, watchEffect } from "vue";
import Loading from "vue-loading-overlay";
// import "vue-loading-overlay/dist/css/index.css";
import VueCookies from "vue-cookies";

import { useStore } from "vuex";
export default {
  components: {
    Loading,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const isAuth = ref(store.getters["Rawdata/getisAuthFlag"]);
    const isLoading = ref(true);
    const http = ref(inject("http"));
    const url = ref(inject("url"));
    const items = ref([
      "POWER SEARCH",
      "TREND REPORTS",
      "RETRIEVAL SERVICES",
      "DASHBOARD",
      "PROFILE",
    ]);
    const profile_dropdown_items = ref(["Change Password", "Logout"]);
    const dashboard_dropdown_items = ref([
      "Retail Energy Pricing Dashboard",
      "Digital Dashboard",
      "Retail Promotional Value Dashboard",
    ]);
    // onMounted(() => {
    //   fetch("https://dev02.competiscan.com:5053/data/sectors/372", {
    //     method: "GET",
    //     headers: {
    //       Authorization:
    //         "eyJraWQiOiJxUytUWFFjcitCXC9mK3ZBdzJ2QWl4c1hqUVZPZFRVaURrM2RIQkVlZ1hNaz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDI2N2NjNC02MDViLTRhMmItOTlhZi1mMDE5MDk3NTUyODYiLCJldmVudF9pZCI6IjU2YWJlMDkzLTJjYTgtNDA1Zi1iN2NkLWUxODM0YTBkMGEyYiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2ODg0NjA3MjQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2ZMWVVwdVBWZyIsImV4cCI6MTY4ODQ2MjUyNCwiaWF0IjoxNjg4NDYwNzI0LCJqdGkiOiIyNjhjMDY0Yy1lNWNhLTRhNTQtODQ2My0wZWIxOWY2MDEwNzIiLCJjbGllbnRfaWQiOiIyZzU0cWtxajNwbHRqcWN2ZDE4YmR2Z3F2MCIsInVzZXJuYW1lIjoiYXJ2aW5kbm1nIn0.efQRa1v2ZkzEL62JO9VEuQpglne1jXJ8SG70W-suPAag97NoCAkXAB2AXNGyMJ7AKiTdDRDbwKTFeVOkq2fJFJQ_RPfh7ZbijtQwrw1bvxcM17RyQXZaRKDQ_seSeDeg8pU3upUwBf7IgBP4OLPXRUNbNzmecIrnXkG9CRWeWoDx6AXDP8FzIMYBjWeb5birOBPGaAziltLt85SmCYui45Qwq4aZq9bev1J14TIYy2WWDwg2MaCMFiw5pTw7KpIfyUYMHBJ4T-qgpnqQmYRj-wbWj7Ljjg3HoRkBXJOjJS_lKedilLSIYjgVpPDQxxJEoGXz7-X7gYwAGXZNnG8W9g",
    //       Userid: 356,
    //       Roleid: 1,
    //     },
    //   })
    //     .then((response) => {
    //       response.json().then((data) => {
    //         console.log("2data", data);
    //         store.dispatch("Sector/setSectorDropdownDataAPI", data);
    //       });
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    // });
    onMounted(() => {
      // let view = this;
      // https://product.staging.competiscan.com/data/rawdata
      // fetch("https://api7.competiscan.com/product/v1/data/rawdata", {
      //   method: "GET",
      //   headers: {
      //     Authorization:
      //       "eyJraWQiOiJxUytUWFFjcitCXC9mK3ZBdzJ2QWl4c1hqUVZPZFRVaURrM2RIQkVlZ1hNaz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDI2N2NjNC02MDViLTRhMmItOTlhZi1mMDE5MDk3NTUyODYiLCJldmVudF9pZCI6IjU2YWJlMDkzLTJjYTgtNDA1Zi1iN2NkLWUxODM0YTBkMGEyYiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2ODg0NjA3MjQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2ZMWVVwdVBWZyIsImV4cCI6MTY4ODQ2MjUyNCwiaWF0IjoxNjg4NDYwNzI0LCJqdGkiOiIyNjhjMDY0Yy1lNWNhLTRhNTQtODQ2My0wZWIxOWY2MDEwNzIiLCJjbGllbnRfaWQiOiIyZzU0cWtxajNwbHRqcWN2ZDE4YmR2Z3F2MCIsInVzZXJuYW1lIjoiYXJ2aW5kbm1nIn0.efQRa1v2ZkzEL62JO9VEuQpglne1jXJ8SG70W-suPAag97NoCAkXAB2AXNGyMJ7AKiTdDRDbwKTFeVOkq2fJFJQ_RPfh7ZbijtQwrw1bvxcM17RyQXZaRKDQ_seSeDeg8pU3upUwBf7IgBP4OLPXRUNbNzmecIrnXkG9CRWeWoDx6AXDP8FzIMYBjWeb5birOBPGaAziltLt85SmCYui45Qwq4aZq9bev1J14TIYy2WWDwg2MaCMFiw5pTw7KpIfyUYMHBJ4T-qgpnqQmYRj-wbWj7Ljjg3HoRkBXJOjJS_lKedilLSIYjgVpPDQxxJEoGXz7-X7gYwAGXZNnG8W9g",
      //     Userid: 492,
      //     Roleid: 1,
      //   },
      // })
      //   .then((response) => {
      //     response.json().then((data) => {
      //       console.log("2data", data);
      //       store.dispatch("Rawdata/setDropdownDataAPI", data);
      //       isLoading.value = false;
      //       // console.log("sss", loading.value);
      //       // console.log(mediachannel.value, 2233);
      //     });
      //   })
      //   .catch((err) => {
      //     console.error(err);
      //   });
      //productNameAPI();
      // console.log(lastsearch, "lastsearch");
    });

    watchEffect(() => {
      // if (store.getters["Rawdata/getisAuthFlag"]) {
      //   // alert(true)
      //   console.log(store.getters["Rawdata/getisAuthFlag"], " flag");

      //   isAuth.value = store.getters["Rawdata/getisAuthFlag"];
      // }
      // var tokenFound = localStorage.getItem("access_token");

      // if (tokenFound) store.dispatch("Rawdata/setisAuthLogin", true);
      let rawd = JSON.parse(localStorage.getItem("rawData"));
      let raw_add = JSON.parse(localStorage.getItem("raw_additional"));
      let allsector = JSON.parse(localStorage.getItem("Allsector"));
      // let excelCheckboxeslocal = JSON.parse(
      //   localStorage.getItem("myexcelBoxes")
      // );
      // console.log(12, rawd);
      if (!rawd) {
        isLoading.value = true;
        rawdata();
      } else {
        store.dispatch("Rawdata/setDropdownDataAPI", rawd);
        let originManipulated = convertToArrays(
          store.getters["Rawdata/getDropdownDataAPI"].offer_origin
        );
        store.dispatch("Rawdata/setofferOriginChangedAct", originManipulated);
      }
      if (!raw_add) {
        raw_additional();
      } else {
        store.dispatch("Rawdata/rawAdditionalAction", raw_add.payload);
      }
      if (!allsector) {
        isLoading.value = true;
        allSectorsChildren();
      } else {
        findAndPrintChildren(allsector.payload);
      }
      // if (!excelCheckboxeslocal) {
      //   checkBoxes();
      // } else {
      //   store.dispatch("Myexcel/setExcelCheckBoxesNames", excelCheckboxeslocal);
      // }
    });
    function convertToArrays(objects) {
      // console.log(objects);
      // console.log(typeof objects);
      return objects.map((obj) => {
        obj.oo_sectorID = obj.oo_sectorID.split(",").map(Number);
        return obj;
      });
    }

    function profileChildrenEvents(name) {
      if (name === "Logout") {
        // console.log(VueCookies.get("access_token"));
        VueCookies.remove("access_token", null, "competiscan.com");
        window.location.replace(url(URL));
      }
    }
    function rawdata() {
      console.log("raw data called");
      isLoading.value = true;
      fetch(`${http.value.rawData_Url}`, {
        method: "GET",
        headers: {
          Authorization:
            "eyJraWQiOiJxUytUWFFjcitCXC9mK3ZBdzJ2QWl4c1hqUVZPZFRVaURrM2RIQkVlZ1hNaz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDI2N2NjNC02MDViLTRhMmItOTlhZi1mMDE5MDk3NTUyODYiLCJldmVudF9pZCI6IjU2YWJlMDkzLTJjYTgtNDA1Zi1iN2NkLWUxODM0YTBkMGEyYiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2ODg0NjA3MjQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2ZMWVVwdVBWZyIsImV4cCI6MTY4ODQ2MjUyNCwiaWF0IjoxNjg4NDYwNzI0LCJqdGkiOiIyNjhjMDY0Yy1lNWNhLTRhNTQtODQ2My0wZWIxOWY2MDEwNzIiLCJjbGllbnRfaWQiOiIyZzU0cWtxajNwbHRqcWN2ZDE4YmR2Z3F2MCIsInVzZXJuYW1lIjoiYXJ2aW5kbm1nIn0.efQRa1v2ZkzEL62JO9VEuQpglne1jXJ8SG70W-suPAag97NoCAkXAB2AXNGyMJ7AKiTdDRDbwKTFeVOkq2fJFJQ_RPfh7ZbijtQwrw1bvxcM17RyQXZaRKDQ_seSeDeg8pU3upUwBf7IgBP4OLPXRUNbNzmecIrnXkG9CRWeWoDx6AXDP8FzIMYBjWeb5birOBPGaAziltLt85SmCYui45Qwq4aZq9bev1J14TIYy2WWDwg2MaCMFiw5pTw7KpIfyUYMHBJ4T-qgpnqQmYRj-wbWj7Ljjg3HoRkBXJOjJS_lKedilLSIYjgVpPDQxxJEoGXz7-X7gYwAGXZNnG8W9g",
          Userid: 492,
          Roleid: 1,
          Accept: "*/*",
        },
      })
        .then((response) => {
          response.json().then((data) => {
            // console.log("2data", data);
            localStorage.setItem("rawData", JSON.stringify(data));
            store.dispatch("Rawdata/setDropdownDataAPI", data);
            // console.log("sss", loading.value);
            let originManipulated = convertToArrays(
              store.getters["Rawdata/getDropdownDataAPI"].offer_origin
            );
            store.dispatch(
              "Rawdata/setofferOriginChangedAct",
              originManipulated
            );
            // console.log(mediachannel.value, 2233);
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }
    function checkBoxes() {
      fetch(`${http.value.myexcelcheckbox}`, {
        method: "GET",
      })
        .then((response) => {
          response.json().then((data) => {
            console.log("3data", data);
            localStorage.setItem("myexcelBoxes", JSON.stringify(data));
            store.dispatch("Myexcel/setExcelCheckBoxesNames", data);
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }
    function raw_additional() {
      isLoading.value = true;
      fetch(`${http.value.raw_additional}`, {
        method: "GET",
      })
        .then((response) => {
          response.json().then((data) => {
            console.log("3data", data);
            localStorage.setItem("raw_additional", JSON.stringify(data));
            store.dispatch("Rawdata/rawAdditionalAction", data.payload);
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }
    function allSectorsChildren() {
      isLoading.value = true;
      fetch(`${http.value.allsector}`, {
        method: "GET",
        headers: {
          Authorization:
            "eyJraWQiOiJxUytUWFFjcitCXC9mK3ZBdzJ2QWl4c1hqUVZPZFRVaURrM2RIQkVlZ1hNaz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDI2N2NjNC02MDViLTRhMmItOTlhZi1mMDE5MDk3NTUyODYiLCJldmVudF9pZCI6IjU2YWJlMDkzLTJjYTgtNDA1Zi1iN2NkLWUxODM0YTBkMGEyYiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2ODg0NjA3MjQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2ZMWVVwdVBWZyIsImV4cCI6MTY4ODQ2MjUyNCwiaWF0IjoxNjg4NDYwNzI0LCJqdGkiOiIyNjhjMDY0Yy1lNWNhLTRhNTQtODQ2My0wZWIxOWY2MDEwNzIiLCJjbGllbnRfaWQiOiIyZzU0cWtxajNwbHRqcWN2ZDE4YmR2Z3F2MCIsInVzZXJuYW1lIjoiYXJ2aW5kbm1nIn0.efQRa1v2ZkzEL62JO9VEuQpglne1jXJ8SG70W-suPAag97NoCAkXAB2AXNGyMJ7AKiTdDRDbwKTFeVOkq2fJFJQ_RPfh7ZbijtQwrw1bvxcM17RyQXZaRKDQ_seSeDeg8pU3upUwBf7IgBP4OLPXRUNbNzmecIrnXkG9CRWeWoDx6AXDP8FzIMYBjWeb5birOBPGaAziltLt85SmCYui45Qwq4aZq9bev1J14TIYy2WWDwg2MaCMFiw5pTw7KpIfyUYMHBJ4T-qgpnqQmYRj-wbWj7Ljjg3HoRkBXJOjJS_lKedilLSIYjgVpPDQxxJEoGXz7-X7gYwAGXZNnG8W9g",
        },
      })
        .then((response) => {
          response.json().then((data) => {
            console.log("secchildren", data);
            localStorage.setItem("Allsector", JSON.stringify(data));
            // store.dispatch("Sector/setallSectorsChildren", data.payload);
            findAndPrintChildren(data.payload);
            isLoading.value = false;
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }

    async function findAndPrintChildren(data) {
      let categories = [];
      let subcategories = [];
      let subsubcategories = [];

      data.forEach((item) => {
        if ("id" in item && "children" in item) {
          // categories.push(item)

          // console.log(item.children.length);
          item.children.forEach((child) => {
            if ("children" in child) {
              if (child.children.length > 0) {
                // eslint-disable-next-line no-unused-vars
                for (const [key, value] of Object.entries(child.children)) {
                  if (value.children) {
                    if (value.children.length > 0) {
                      //  console.log(value.children)
                      // eslint-disable-next-line no-unused-vars
                      for (const [k, v] of Object.entries(value.children)) {
                        // console.log(k);
                        subsubcategories.push({
                          pid: item.id,
                          subpid: child.id,
                          subsubpid: value.id,
                          ...v,
                        });
                      }
                    }
                  }
                  // console.log(key, value);
                  // console.log("pid", item.id);
                  // console.log("subpid", child.id);
                  subcategories.push({
                    pid: item.id,
                    subpid: child.id,
                    ...value,
                  });
                  // console.log(child.children)
                }
              }
            }
            categories.push({ pid: item.id, ...child });
          });
        }
      });
      store.dispatch("Sector/setAllCategoryLocalAction", categories);
      store.dispatch("Sector/setAllSubCategoryLocalAction", subcategories);
      store.dispatch(
        "Sector/setAllSubSubCategoryLocalAction",
        subsubcategories
      );
      // console.log("cat", categories);
      // console.log("subcat", subcategories);
      // console.log("subsubcat", subsubcategories);
    }
    function productNameAPI() {
      fetch(`${http.value.CompanyProductname}`)
        .then((response) => {
          // Check if the response status is OK (200)
          if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status}`);
          }
          // Parse the response JSON
          return response.json();
        })
        .then((data) => {
          // Work with the fetched data
          // console.log("yyyy.", data);
          store.dispatch("Rawdata/setproductCompaniesNamesAction", data.data);
          // You can update your UI or perform other actions with the data here
        })
        .catch((error) => {
          // Handle errors, such as network issues or invalid JSON
          console.error("Fetch error:", error);
        });
    }

    function checkMenuSelection(item) {
      if (item === "RETRIEVAL SERVICES") {
        router.push({ path: "DateCalendar" });
      }
      if (item === "POWER SEARCH") {
        router.push("/power_search");
      }
    }
    return {
      items,
      profile_dropdown_items,
      dashboard_dropdown_items,
      checkMenuSelection,
      productNameAPI,
      allSectorsChildren,
      rawdata,
      findAndPrintChildren,
      profileChildrenEvents,
      isAuth,
      checkBoxes,
    };
  },
};
</script>
<style>
.v-img__img,
.v-img__picture,
.v-img__gradient,
.v-img__placeholder,
.v-img__error {
  width: 99%;
}
.scroll-bar::-webkit-scrollbar {
  width: 10px;
}

.scroll-bar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 12px;
}

.scroll-bar::-webkit-scrollbar-thumb {
  background-color: rgb(185, 185, 185);
  border-radius: 50px;
}

.dropdown-items {
  cursor: pointer;
}
</style>
